<script setup>
// NOOVI: Resumo de KPIs do Pipeline Pro na Overview de Reports (Gap D — fase-10).
// Reusa o endpoint de analytics existente (win_rate) — uma chamada entrega
// win_rate, total_open, total_won, total_lost. Read-only, feature-gated em
// LiveReports.vue (pipeline_board).
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper';
import MetricCard from './overview/MetricCard.vue';
import AnalyticsAPI from 'dashboard/api/pipeline/analytics';

const { t } = useI18n();
const route = useRoute();

const isLoading = ref(true);
const metrics = ref({
  win_rate: 0,
  total_open: 0,
  total_won: 0,
  total_lost: 0,
});

const pipelineUrl = frontendURL(`accounts/${route.params.accountId}/pipeline`);

onMounted(async () => {
  try {
    const { data } = await AnalyticsAPI.getWinRate();
    metrics.value = { ...metrics.value, ...data };
  } catch (error) {
    // Seção opcional — falha silenciosa para não quebrar a Overview.
  } finally {
    isLoading.value = false;
  }
});
</script>

<template>
  <MetricCard
    :is-loading="isLoading"
    :loading-message="t('PIPELINE.OVERVIEW.LOADING')"
  >
    <template #header>
      <div class="flex items-center gap-2 flex-row">
        <h5 class="mb-0 text-n-slate-12 font-medium text-lg">
          {{ t('PIPELINE.OVERVIEW.HEADER') }}
        </h5>
      </div>
      <div class="flex flex-row items-center justify-end gap-2">
        <router-link
          :to="pipelineUrl"
          class="text-sm font-medium text-n-slate-11 hover:text-n-slate-12"
        >
          {{ t('PIPELINE.OVERVIEW.VIEW_PIPELINE') }}
        </router-link>
      </div>
    </template>
    <div class="flex flex-row w-full justify-between gap-4">
      <div class="flex flex-col">
        <span class="text-2xl font-semibold text-n-slate-12">
          {{ `${metrics.win_rate}%` }}
        </span>
        <span class="text-sm text-n-slate-11">
          {{ t('PIPELINE.OVERVIEW.WIN_RATE') }}
        </span>
      </div>
      <div class="flex flex-col">
        <span class="text-2xl font-semibold text-n-slate-12">
          {{ metrics.total_open }}
        </span>
        <span class="text-sm text-n-slate-11">
          {{ t('PIPELINE.OVERVIEW.OPEN') }}
        </span>
      </div>
      <div class="flex flex-col">
        <span class="text-2xl font-semibold text-n-slate-12">
          {{ metrics.total_won }}
        </span>
        <span class="text-sm text-n-slate-11">
          {{ t('PIPELINE.OVERVIEW.WON') }}
        </span>
      </div>
      <div class="flex flex-col">
        <span class="text-2xl font-semibold text-n-slate-12">
          {{ metrics.total_lost }}
        </span>
        <span class="text-sm text-n-slate-11">
          {{ t('PIPELINE.OVERVIEW.LOST') }}
        </span>
      </div>
    </div>
  </MetricCard>
</template>
